var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasItems
    ? _c(
        "div",
        { staticClass: "brand-filter d-flex flex-wrap" },
        _vm._l(_vm.items, function (item) {
          return _c("item", {
            key: item.id,
            class: { active: _vm.isActive(item) },
            attrs: {
              value: item,
              stats: _vm.getItemStats(item),
              "base-url": _vm.baseUrl,
            },
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }